import { Mail, StickyNote, CalendarCheck } from 'lucide-react';
import type { TimelineEventKind } from '../hooks/useCommunicationTimeline.js';

interface Props {
  selected: TimelineEventKind[];
  onChange: (kinds: TimelineEventKind[]) => void;
}

const ITEMS: { kind: TimelineEventKind; label: string; icon: React.ReactNode; color: string }[] = [
  {
    kind: 'email',
    label: 'Emails',
    icon: <Mail className="h-3.5 w-3.5" />,
    color: 'text-sky-700',
  },
  {
    kind: 'note',
    label: 'Notes',
    icon: <StickyNote className="h-3.5 w-3.5" />,
    color: 'text-amber-700',
  },
  {
    kind: 'rdv',
    label: 'RDV',
    icon: <CalendarCheck className="h-3.5 w-3.5" />,
    color: 'text-emerald-700',
  },
];

/**
 * Composant dédié — filtres de la timeline.
 * Multi-sélection. Vide = tout.
 */
export function TimelineFilters({ selected, onChange }: Props) {
  function toggle(k: TimelineEventKind) {
    if (selected.includes(k)) {
      onChange(selected.filter((s) => s !== k));
    } else {
      onChange([...selected, k]);
    }
  }
  return (
    <div className="flex items-center gap-1">
      <span className="text-[10px] uppercase tracking-wider text-neutral-500">Filtrer :</span>
      {ITEMS.map((it) => {
        const isActive = selected.length === 0 || selected.includes(it.kind);
        return (
          <button
            key={it.kind}
            type="button"
            onClick={() => toggle(it.kind)}
            className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-semibold transition-all ${
              isActive
                ? `${it.color} bg-white ring-1 ring-neutral-300`
                : 'text-neutral-400 ring-1 ring-transparent hover:bg-neutral-100'
            }`}
          >
            {it.icon}
            {it.label}
          </button>
        );
      })}
    </div>
  );
}
